<template>
    <div class="column">
        <div class="advanced-search-card card">
            <div class="card-content">
                <div class="media">
                    <div class="media-left">
                        <figure class="image is-65x65" @click="openGallery">
                            <img :src="lot.IMAGES.split('#')[0]">
                        </figure>
                    </div>
                    <div class="media-content">
                        <div class="subtitle is-6"><b><span class="car-name">{{ lot.MODEL_NAME }} {{ lot.GRADE }}</span></b></div>
                        <p class="title is-6"><b>{{ lot.LOT }} /</b> {{ lot.YEAR }} </p>
                        <p class="details"><span v-html="lot.KUZOV"></span>/ {{ lot.ENG_V }} cc / {{ lot.MILEAGE | formatNumber }} km </p>
                        <p class="details">{{ lot.COLOR }} / {{ lot.KPP  }} / {{ lot.RATE }}</p>
                    </div>
                </div>

                <div class="content ">
                    <a href="#" class="auction"  @click="goToLotSinglePage" >
                        {{ lot.AUCTION_DATE.split(' ')[1] }}
                        {{ lot.AUCTION_DATE.split(' ')[0] }}
                        @ {{ lot.AUCTION }}</a>
                </div>
                <div class="card-footer">
                    <div class="color-danger">RESULT: {{ lot.FINISH | formatNumber }} YEN</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props:['lot', 'index'],
        methods: {
            openStatisticsModal() {
                this.$store.dispatch('changeMarketPriceModalSelectedLot', this.lot)
                this.$store.dispatch('changeMarketPriceModalStatus', { status: true, lotId: this.lot.lot_id })
                this.$store.dispatch('fetchMarketPriceModalLots')
            },
            goToLotSinglePage() {
                this.$store.dispatch('setLotToIsVisited', this.lot.lot_id)
                this.$router.push({
                    path: '/single/' + this.lot.lot_id,
                })
            },
            openBidModal() {
                this.$store.dispatch('changeResultBiddingModalStatus', { status: true, lot: this.lot })
                this.$store.dispatch('fetchGroups', {date: this.lot.date})
                this.$store.dispatch('fetchGroupSettings')
                this.$store.dispatch('changeSearchResultActiveLotKey', this.index)
            },
            openGallery() {
                this.$store.dispatch('setResultGalleryItems', [this.lot.IMAGES.split('#')[0].slice(0, -5), this.lot.IMAGES.split('#')[1].slice(0, -5)])
                this.$store.dispatch('setResultGalleryOptions', { index: 0 })
                this.$store.dispatch('setResultGalleryStatus', true)
            },
            bidIsOpen(lot_date){
                return true
            }
        }
    }
</script>

<style scoped>
    p {
        max-width: 170px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .auction {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #4a4a4a;
    }

    .car-name {
        overflow: hidden;
        max-width: 100%;
        word-wrap: break-word;
        display: inline-block;
        text-overflow: ellipsis;
    }
    .card-content {
        padding: 10px !important;
    }
    .column {
        padding: 5px !important;
    }
    .image {
        width: 135px;
        cursor: pointer;
    }

    .card-footer-item {
        padding: 2px !important;
    }

    .card-footer-item:not(:last-child) {
        border-right: none !important;
    }

    .card-footer {
        border-top: none !important;
    }

    .title {
        margin-top: 5px !important;
        margin-bottom: 5px !important;
    }

    .subtitle {
        margin-bottom: 5px !important;
    }

    .title:not(.is-spaced)+.subtitle {
         margin-top: 0 !important;
    }

    .details {
        font-size: 12px !important;
        margin-top: 10px;
    }

    .content {
        margin-bottom: 5px !important;
    }

    .card .media:not(:last-child) {
        margin-bottom: 5px !important;
    }

    .is-visited {
        background: #a9ddff !important;
    }
    .has-bid {
        background: #f8dcff !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/PastAuctions/PastAuctionMobile.vue